import { useLazyQuery } from '@apollo/client';
import { GET_CUSTOMER_PLAN } from '../apollo/globalConfig';
import {
  ICustomerPlanQuery,
  ICustomerPlanQueryVariables,
  IMaxSeatsFieldsFragment,
} from '../apollo/graphqlSchema';
import { MaybeNil } from '../interfaces';
import { useCallback } from 'react';
import { useAppDispatch } from '../../redux/hooks';
import { useBootstrapSelector } from '../../redux/selectorHooks';
import { updateCustomerPlan } from '../../redux/slices/bootstrap';

export const getMaxSeatsTooltip = (
  maxSeats: MaybeNil<IMaxSeatsFieldsFragment>,
) => {
  if (!maxSeats) {
    return null;
  }

  return (
    `Max Seats ${maxSeats.maxSeats} has reached. ` +
    `Please contact your admin to reduce the number of active users.`
  );
};

const useCustomerPlan = () => {
  const dispatch = useAppDispatch();
  const { maxSeats, maxSchemas, hasAvailableSchemas, reachMaxSeats, mtuPlan } =
    useBootstrapSelector('customerPlan');

  const onDataLoaded = useCallback(
    (data: ICustomerPlanQuery) => {
      dispatch(updateCustomerPlan(data.customerPlan));
    },
    [dispatch],
  );

  const [, { loading, refetch: refetchCustomerPlan }] = useLazyQuery<
    ICustomerPlanQuery,
    ICustomerPlanQueryVariables
  >(GET_CUSTOMER_PLAN, {
    onCompleted: onDataLoaded,
    notifyOnNetworkStatusChange: true,
  });

  return {
    maxSeats,
    maxSchemas,
    refetchCustomerPlan,
    loading,
    hasAvailableSchemas,
    reachMaxSeats,
    mtuPlan,
  };
};

export default useCustomerPlan;
